<ng-container *ngIf="muted">
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.93945 4.00488H1.10742C1.05261 4.00504 1.01474 4.02526 1 4.03809V8.04785C1.0142 8.06063 1.05167 8.08187 1.10742 8.08203H3.97168C4.30885 8.08207 4.64375 8.18954 4.91992 8.39453L5.03516 8.48828L5.03906 8.49219L6.75488 10.0596V7.82031L7.75488 8.82031V11.1084C7.75471 11.3131 7.61884 11.4977 7.41406 11.5762C7.20639 11.6543 6.96838 11.6106 6.81055 11.4658L4.36523 9.23047C4.26008 9.1358 4.11819 9.08208 3.97168 9.08203H1.10742C0.814079 9.08188 0.531784 8.97519 0.324219 8.78516C0.116816 8.59529 3.17377e-06 8.33779 0 8.06934V4.01758C0.000234013 3.7492 0.116713 3.49148 0.324219 3.30176C0.531764 3.11185 0.814182 3.00504 1.10742 3.00488H1.93945L2.93945 4.00488ZM10.2559 11.3223C10.0185 11.3956 9.77481 11.4566 9.52539 11.5029C9.22577 11.5586 8.93299 11.3811 8.87207 11.1074C8.81155 10.8336 9.00552 10.5664 9.30469 10.5107C9.34338 10.5035 9.38156 10.4943 9.41992 10.4863L10.2559 11.3223ZM9.52539 0.584961C12.3051 1.10178 14.4003 3.35076 14.4004 6.04395C14.4004 7.6734 13.6316 9.13825 12.4102 10.1572L11.6641 9.41113C12.6637 8.57723 13.292 7.37739 13.292 6.04395C13.2919 3.84078 11.5789 2.00006 9.30469 1.57715C9.00532 1.52142 8.81114 1.25347 8.87207 0.979492C8.93327 0.706115 9.22598 0.529359 9.52539 0.584961ZM9.11035 3.29883C9.26816 3.20526 9.4651 3.19023 9.63672 3.25879C10.8108 3.72803 11.6308 4.79926 11.6309 6.04395C11.6309 6.93386 11.21 7.73312 10.542 8.28906L8.86133 6.6084V3.72266C8.8614 3.55181 8.95532 3.39223 9.11035 3.29883ZM6.81055 0.621094C6.96828 0.476593 7.2066 0.43282 7.41406 0.510742C7.6188 0.589161 7.7546 0.774885 7.75488 0.979492V5.50195L6.75488 4.50195V2.02637L5.46094 3.20801L4.75391 2.50098L6.81055 0.621094Z"
      [ngStyle]="{ fill: _offColor }"
    />
    <rect
      x="0.645996"
      y="0.995361"
      width="1.40795"
      height="16.4261"
      rx="0.703976"
      transform="rotate(-45 0.645996 0.995361)"
      [ngStyle]="{ fill: _offColor }"
    />
  </svg>
</ng-container>
<ng-container *ngIf="!muted">
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.2373 0.506836C7.24656 0.510707 7.25204 0.514784 7.25488 0.517578V10.623C7.25221 10.6258 7.24742 10.6316 7.2373 10.6357C7.22071 10.6419 7.20106 10.643 7.18262 10.6396C7.16429 10.6362 7.15329 10.6294 7.14844 10.625L7.14746 10.624L4.70215 8.38867L4.7002 8.38672L4.62207 8.32324C4.43415 8.18361 4.20464 8.10941 3.97168 8.10938H1.10742C0.932703 8.10928 0.772853 8.04553 0.662109 7.94434L0.661133 7.94336C0.552002 7.8434 0.500003 7.71784 0.5 7.59668V3.54492C0.500052 3.42378 0.551994 3.29817 0.661133 3.19824H0.662109C0.772868 3.09684 0.932492 3.03232 1.10742 3.03223H3.97168C4.2378 3.03218 4.49996 2.93556 4.7002 2.75488L4.70215 2.75293L7.14746 0.517578L7.14844 0.516602C7.15334 0.51217 7.16438 0.505342 7.18262 0.501953L7.2373 0.506836Z"
      [ngStyle]="{ stroke: strokeColor }"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.30425 1.10419C11.5786 1.52707 13.2921 3.3675 13.2921 5.57079C13.2921 7.77408 11.5786 9.6145 9.30425 10.0374C9.00486 10.0931 8.81098 10.3608 8.87191 10.6347C8.93284 10.9085 9.22559 11.0857 9.52525 11.03C12.305 10.5132 14.3999 8.26406 14.3999 5.57079C14.3999 2.87751 12.305 0.628384 9.52525 0.111556C9.22559 0.0558471 8.93284 0.233103 8.87191 0.506837C8.81098 0.780824 9.00486 1.04848 9.30425 1.10419Z"
      [ngStyle]="{ fill: fillColor }"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.6362 2.78567C9.46449 2.71705 9.26785 2.73224 9.10998 2.82594C8.95489 2.91938 8.86072 3.07865 8.86072 3.24958V7.89217C8.86072 8.06309 8.95489 8.22237 9.10998 8.31581C9.26785 8.4095 9.46449 8.42469 9.6362 8.35607C10.8105 7.88685 11.6302 6.81572 11.6302 5.57087C11.6302 4.32603 10.8105 3.2549 9.6362 2.78567Z"
      [ngStyle]="{ fill: fillColor }"
    />
  </svg>
</ng-container>
